import DesktopLayout from '../../layouts/DesktopLayout';
import DoneContent from '../shared/DoneContent';

type Props = {
  onComplete: () => Promise<void>;
  continueInApp: boolean;
  deliveryMode: 'redirect' | 'webhook';
};

export default function DesktopDonePage(props: Props) {
  return (
    <DesktopLayout>
      <DoneContent {...props} />
    </DesktopLayout>
  );
}
